import React from "react";
import { iconStyles } from "./iconStyles";
export function FilterIcon() {
    return (<svg className={iconStyles} viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
            <path d="M4 8.625C4 7.1875 5.125 6 6.5625 6H33.375C34.8125 6 36 7.1875 36 8.625C36 9.25 35.75 9.8125 35.375 10.25L25 23.0625V32C25 33.125 24.0625 34 22.9375 34C22.5 34 22.0625 33.875 21.6875 33.5625L15.9375 29C15.3125 28.5 15 27.8125 15 27.0625V23.0625L4.5625 10.25C4.1875 9.8125 4 9.25 4 8.625ZM7.4375 9L17.625 21.5625C17.875 21.875 18 22.1875 18 22.5V26.8125L22 30V22.5C22 22.1875 22.0625 21.875 22.3125 21.5625L32.5625 9H7.4375Z"/>
        </svg>);
}
